// Initialize all cart drawers listeners.
addCartDrawerListeners();

//Get hour for automation of cart drawer
const startDate = new Date(Date.UTC(2024, 0o7, 8, 16, 0, 0)); //in GTM
const endDate = new Date(Date.UTC(2024, 0o7, 31, 21, 59, 59)); //in GTM
const actualDate = new Date();


// Open cart drawer with cart buttons.
function openCartDrawerDirectly(){
    loaderLogo = document.querySelector(".loader-logo");
    loaderLogo.classList.add("hidden");
    document.getElementById("cart-drawer").classList.remove("fadeOutRight");
    document.getElementById("cart-drawer-bg").classList.remove("fadeOut");
    document.getElementById("cart-drawer-bg").classList.remove("hidden");
    document.getElementById("cart-drawer-bg").classList.add("fadeIn");
    document.getElementById("cart-drawer").classList.add("fadeInLeft");
    document.body.style.overflow = "hidden";
};

// Open cart drawer after adding an item to the cart.
function openCartDrawer(){
    loaderLogo = document.querySelector(".loader-logo");
    loaderLogo.querySelector("img").classList.add("fadeOut");
    setTimeout(()=>{
        loaderLogo.classList.add("hidden");
        document.getElementById("cart-drawer").classList.remove("hidden");
        document.getElementById("cart-drawer").classList.remove("fadeOutRight");
        document.getElementById("cart-drawer").classList.add("fadeInLeft");
    }, 300);
    
};

// Function to use pulse loader.
function loaderPulseLogo() {
    loaderLogo = document.querySelector(".loader-logo");
    loaderLogo.classList.remove("hidden");
    loaderLogo.querySelector("img").classList.remove("fadeOut");
    document.getElementById("cart-drawer").classList.add("hidden");
    document.getElementById("cart-drawer-bg").classList.remove("hidden");
    document.body.style.overflow = "hidden";
};


// Close cart drawer.
function closeCartDrawer(){
    loaderLogo = document.querySelector(".loader-logo");
    loaderLogo.querySelector("img").classList.remove("fadeOut");
    document.getElementById("cart-drawer").classList.remove("fadeInLeft");
    document.getElementById("cart-drawer").classList.add("fadeOutRight");
    document.getElementById("cart-drawer-bg").classList.add("fadeOut")
    setTimeout(()=>{
        document.getElementById("cart-drawer-bg").classList.add("hidden");
        document.getElementById("cart-drawer-bg").classList.remove("fadeOut");
    }, 300);
    document.body.style.removeProperty("overflow");
};

// Update cart item counters on the header.
function updateCartCount(count){    
    document.querySelector('#cart-item-count').remove();
    const html = document.createElement('p')
    html.className = 'text-xs';
    html.id = 'cart-item-count';
    html.innerHTML = `
      ${ count }
    `;
    document.querySelector(".cart-count-item-first .cart-count-item-second").appendChild(html);
    document.querySelector('#cart-item-count-mob').remove();
    const htmlMob = document.createElement('p')
    htmlMob.className = 'text-xs';
    htmlMob.id = 'cart-item-count-mob';
    htmlMob.innerHTML = `
      ${ count }
    `;
    document.querySelector(".cart-count-item-first-mob .cart-count-item-second-mob").appendChild(htmlMob);
}

// Add all cart drawer listeners to cart drawer after adding item (cart drawer html is replaced with a new one).
function addCartDrawerListeners() {        
    document.getElementById("cart-drawer-close").addEventListener("click", closeCartDrawer);
    document.getElementById("cart-drawer").addEventListener("click", e => {
        e.stopPropagation();
    });
    document.querySelectorAll(".cart-drawer-quantity-selector button").forEach( button => {
        button.addEventListener("click", async e => {
            e.preventDefault();
            //Get line item key
            const rooItem = button.closest(".cart-drawer-item");
            const key = rooItem.getAttribute("data-key");            
                //Get quantity
                //First check if we are in the 2x1 offer
                if (startDate.getTime() <= actualDate.getTime() && actualDate.getTime() <= endDate.getTime()){
                    const currentQuantity = Number(button.parentElement.querySelector("input").value);
                    const isUp = button.classList.contains("plus");
                    let key_alt = key.slice(0,key.indexOf(":"));
                    const keys = ["44358970081566","44358950650142","44359001145630","44358982304030"];
                    let newQuantity = 0;
                    if (keys.includes(key_alt)) {
                        if (currentQuantity == 1) {
                            newQuantity = isUp ? currentQuantity + 2 : 0;
                        } else {
                            newQuantity = isUp ? currentQuantity + 2 : currentQuantity - 2;
                        }
                    } else {
                        newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
                    };
                        //Ajax update
                    const res = await fetch(`${rootURL}cart/update.js`, {
                        method: 'post',
                        headers: {
                            Accept: "application/json",
                            "Content-type": "application/json",
                        },
                        body: JSON.stringify({updates: { [key]: newQuantity }}),
                    });
                
                    const cart = await res.json();
                    updateCartCount(cart.item_count);
                    //Update cart drawer
                    updateCartDrawer(); 
                } else {
                    const currentQuantity = Number(button.parentElement.querySelector("input").value);
                    const isUp = button.classList.contains("plus");
                    let newQuantity = 0;
                    newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
                    //Ajax update
                    const res = await fetch(`${rootURL}cart/update.js`, {
                        method: 'post',
                        headers: {
                            Accept: "application/json",
                            "Content-type": "application/json",
                        },
                        body: JSON.stringify({updates: { [key]: newQuantity }}),
                    });
                    
                    const cart = await res.json();
                    updateCartCount(cart.item_count);
                    //Update cart drawer
                    updateCartDrawer(); 
                }           
        });
    });
    document.querySelectorAll("input[name='updates[]']").forEach( input => {
        input.addEventListener("keydown", async e => {
            if (e.code == "Enter") {
                //Get line item key
                const rooItem = input.closest(".cart-drawer-item");
                const key = rooItem.getAttribute("data-key");
                //Get quantity
                const newQuantity = Number(input.value);                
                //Ajax update
                const res = await fetch(`${rootURL}cart/update.js`, {
                    method: 'post',
                    headers: {
                        Accept: "application/json",
                        "Content-type": "application/json",
                    },
                    body: JSON.stringify({updates: { [key]: newQuantity }}),
                });
                const cart = await res.json();
                updateCartCount(cart.item_count);
                //Update cart drawer
                updateCartDrawer();
            }
        });
    });
}

// Update cart drawer fetching the new html content and replacing it.
async function updateCartDrawer() {
    const hasScrollTop = document.querySelector(".grow") ?? false;
    const scrollTop = hasScrollTop ? hasScrollTop.scrollTop : null;
    const res = await fetch(`${rootURL}?section_id=cart-drawer`);
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
    const newCartDrawer = html.querySelector("#cart-drawer").innerHTML;
    document.querySelector("#cart-drawer").innerHTML = newCartDrawer;
    const hasNewScrollTop = document.querySelector(".grow") ?? false;
    if (hasNewScrollTop != false) {
         hasScrollTop != false ? document.querySelector(".grow").scrollTop = scrollTop : null;
    };   
    addCartDrawerListeners(); 
};
// Gets the routes URL depending on language of the page.
const rootURL = window.Shopify.routes.root;

// Add the new item to the cart drawer using AJAX.
document.querySelectorAll(`form[action='${rootURL}cart/add']`).forEach( form => {
    form.addEventListener("submit", async e => {
        e.preventDefault();
        // Loader Pulse with logo
        loaderPulseLogo();
        // Get cart
        const res = await fetch(`${rootURL}cart.js`);
        const cart = await res.json();
        const cartCount = Number(cart.item_count);
        const productId = Number(form.querySelector("input[name='id']").value);
        console.log(cart);        
        const itemAdded = cart.items.filter( item => {
            return item.id == productId;
        });
        const hasInputQuantity = form.querySelector("input[name='quantity']") ?? false;   
        // Check if items is already in cart so it doens't add a new one separately.
        if (startDate.getTime() <= actualDate.getTime() && actualDate.getTime() <= endDate.getTime()){
            // This apply when we have 2x1 offer
            if (itemAdded.length > 0) {
                const currentQuantity = itemAdded[0].quantity;
                const key = itemAdded[0].key;
                let key_alt = key.slice(0,key.indexOf(":"));
                const keys = ["44358970081566","44358950650142","44359001145630","44358982304030"];
                let newQuantity = 0;
                if (keys.includes(key_alt)) {
                    newQuantity = hasInputQuantity ? currentQuantity + Number(hasInputQuantity.value) : currentQuantity + 2;
                    // Update cart drawer
                 updateCartCount(Number(hasInputQuantity ?cartCount + Number(hasInputQuantity.value) :cartCount + 2));
                } else {
                    newQuantity = hasInputQuantity ? currentQuantity + Number(hasInputQuantity.value) : currentQuantity + 1;
                    // Update cart drawer
                 updateCartCount(Number(hasInputQuantity ?cartCount + Number(hasInputQuantity.value) :cartCount + 1));
                };
                
                //Ajax update
                const res = await fetch(`${rootURL}cart/update.js`, {
                    method: 'post',
                    headers: {
                        Accept: "application/json",
                        "Content-type": "application/json",
                    },
                    body: JSON.stringify({updates: { [key]: newQuantity }}),
                });            
                 
            } else {
                const key = String(form.querySelector("input[name='id']").value);
                const keys = ["44358970081566","44358950650142","44359001145630","44358982304030"];
                if (keys.includes(key)) {
                // Submit cart form with ajax
                await fetch(`${rootURL}cart/add`,  {
                    method: 'post',
                    body: new FormData(form),
                 });
                //Ajax update
                const res = await fetch(`${rootURL}cart/update.js`, {
                    method: 'post',
                    headers: {
                        Accept: "application/json",
                        "Content-type": "application/json",
                    },
                    body: JSON.stringify({updates: { [key]: 2 }}),
                });
                // Update cart drawer
                updateCartCount(cartCount + 2);     
                } else {
                    // Submit cart form with ajax
                await fetch(`${rootURL}cart/add`,  {
                    method: 'post',
                    body: new FormData(form),
                 });
                 // Update cart drawer
                 updateCartCount(cartCount + 1);
                };
                
                 
            };
        } else {
            if (itemAdded.length > 0) {
                const currentQuantity = itemAdded[0].quantity;
                const key = itemAdded[0].key;
                const newQuantity = hasInputQuantity ? currentQuantity + Number(hasInputQuantity.value) : currentQuantity + 1;
                //Ajax update
                const res = await fetch(`${rootURL}cart/update.js`, {
                    method: 'post',
                    headers: {
                        Accept: "application/json",
                        "Content-type": "application/json",
                    },
                    body: JSON.stringify({updates: { [key]: newQuantity }}),
                });            
                 // Update cart drawer
                 updateCartCount(Number(hasInputQuantity ?cartCount + Number(hasInputQuantity.value) :cartCount + 1));
            } else {
                // Submit cart form with ajax
                await fetch(`${rootURL}cart/add`,  {
                    method: 'post',
                    body: new FormData(form),
                 });
                 // Update cart drawer
                 updateCartCount(cartCount + 1);
            };
        }     
        // Update cart drawer
        await updateCartDrawer();
        openCartDrawer();        
    })});

// Update cart count desktop.
document.querySelector(".cart-count-item-first").addEventListener("click", e => {
    e.preventDefault();
    openCartDrawerDirectly();
    });

// Update cart count desktop.
document.querySelector(".cart-count-item-first-mob").addEventListener("click", e => {
    e.preventDefault();
    openCartDrawerDirectly();
    });

// Close cart drawer.
document.getElementById("cart-drawer-bg").addEventListener("click", closeCartDrawer);